import create from 'zustand'
import { persist } from "zustand/middleware"

const persistConfig = {
  name: "register-with-line-callback"
};

const registerWithLineCallbackStore = create(persist((set, get) => {

  const setSuccessPathAction = async (successPath) => {
    set({ successPath })
  }

  const setDataAction = async (lineId, accessToken, email, firstname) => {
    const data = {
      lineId, accessToken, email, firstname
    }
    set({ data })
  }

  const clearAllAction = () => set({
    ...initState
  })

  const initState = {
    successPath: null,
    data: null,
  }
  
  return {
    ...initState,
    setSuccessPath: setSuccessPathAction,
    setData: setDataAction,
    clearAll: clearAllAction,
  }
}, persistConfig));

export default registerWithLineCallbackStore;